import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Option } from '@digilize/shared/definitions/src';
import { TranslateService } from '@ngx-translate/core';
import { Profession } from '../../models/profession.model';
import { ProfessionMockService } from '../../services/profession-mock.service';

@Component({
  selector: 'bwc-professions-list',
  templateUrl: './professions-list.component.html',
  styleUrls: ['./professions-list.component.scss'],
})
export class ProfessionsListComponent implements OnInit {
  professions: Profession[] = [];
  visibleCount = 30;
  likedIds: number[] = [];
  selectedVakgebied = '';
  selectedOpleidingsniveau = '';

  vakgebiedControl = new FormControl('');
  opleidingsniveauControl = new FormControl('');
  vakgebiedOptions: Option[] = [];
  opleidingsniveauOptions: Option[] = [];

  constructor(
    private professionService: ProfessionMockService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.professionService.getProfessions().subscribe(p => (this.professions = p));
    this.likedIds = this.professionService.getSavedIds();

    this.vakgebiedOptions = [
      { text: this.translateService.instant('shared.all_fields'), val: '' },
      { text: this.translateService.instant('shared.filters.ict'), val: 'ict' },
      { text: this.translateService.instant('shared.filters.sales'), val: 'sales' },
      { text: this.translateService.instant('shared.filters.care'), val: 'zorg' },
      { text: this.translateService.instant('shared.filters.education_sector'), val: 'onderwijs' },
      { text: this.translateService.instant('shared.filters.marketing'), val: 'marketing' },
      { text: this.translateService.instant('shared.filters.hr'), val: 'hr' },
    ];
    this.opleidingsniveauOptions = [
      { text: this.translateService.instant('shared.all_levels'), val: '' },
      { text: this.translateService.instant('shared.filters.mbo'), val: 'mbo' },
      { text: this.translateService.instant('shared.filters.hbo'), val: 'hbo' },
      { text: this.translateService.instant('shared.filters.wo'), val: 'wo' },
    ];
  }

  get visibleProfessions(): Profession[] {
    return this.professions.slice(0, this.visibleCount);
  }

  get hasMore(): boolean {
    return this.visibleCount < this.professions.length;
  }

  loadMore(): void {
    this.visibleCount = Math.min(this.visibleCount + 30, this.professions.length);
  }

  isLiked(id: number): boolean {
    return this.likedIds.includes(id);
  }

  toggleLike(profession: Profession): void {
    const saved = this.professionService.toggleSaveProfession(profession);
    this.likedIds = saved
      ? [...this.likedIds, profession.id]
      : this.likedIds.filter(id => id !== profession.id);
  }

  onVakgebiedSelected(option: Option): void {
    this.selectedVakgebied = option.val;
  }

  onOpleidingsniveauSelected(option: Option): void {
    this.selectedOpleidingsniveau = option.val;
  }
}
